/**
 * MascaraTransportadorSacPublicoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {MascaraTransportadorSacPublico} from '@/model/resource/MascaraTransportadorSacPublico'

/* TODO: review generated class */
@HttpExclude()
export class MascaraTransportadorSacPublicoCollection extends PageCollection<
  MascaraTransportadorSacPublico
> {
  constructor() {
    super(MascaraTransportadorSacPublico)
  }

  queryAsPage() {
    return this.listMascaraTransportadorSacPublico()
  }

  async listMascaraTransportadorSacPublico() {
    return await Request.get(`/admin/mascara-transportador-sac-publico`, {
      params: this.params,
    })
      .name('listMascaraTransportadorSacPublico')
      .as(this)
      .getResponse()
  }

  async listCsvMascaraTransportadorSacPublico() {
    return await Request.get(`/admin/mascara-transportador-sac-publico/csv`, {
      params: this.params,
    })
      .name('listCsvMascaraTransportadorSacPublico')
      .as(this)
      .getResponse()
  }
}
